// Copied verbatim from tsc.common/Services/ServicePlan/Rendering/Pricing/ServicePlanFeeKeys.cs
// (story e9-1) — a backend key rename breaks this loudly via a missing-dictionary-key fallback
// (GetLineItemFee below) rather than silently mislabeling a review-screen fee row.
export const SERVICE_PLAN_FEE_KEYS = {
  AnnualSupportPackage: 'AnnualSupportPackage',
  HearingLanguageFee: 'HearingLanguageFee',
  AdditionalServicesTotal: 'AdditionalServicesTotal',
  CfssTotal: 'CfssTotal',
  AudiologyTotal: 'AudiologyTotal',
  TotalFee: 'TotalFee',

  CommunityVisits: 'CommunityVisits',
  TravelToYou: 'TravelToYou',
  CollaborativeCareCfss: 'CollaborativeCareCfss',
  CollaborativeCareAud: 'CollaborativeCareAud',
  AdditionalCommunicationAssessment: 'AdditionalCommunicationAssessment',
  StartingSchoolReport: 'StartingSchoolReport',
  SocialEmotionalAssessment: 'SocialEmotionalAssessment',
  SpeechPerceptionTesting: 'SpeechPerceptionTesting',
  AnnualSpeechPerception: 'AnnualSpeechPerception',
  TalkTogether: 'TalkTogether',
} as const

export function getLineItemFee(
  lineItemFees: Record<string, number>,
  key: string,
): number {
  return lineItemFees[key] ?? 0
}
